// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","table-header-bg-color":"#f4f8fb","tabs":"outPatientList_tabs__dfOou"};